import getObj from './methods/getObj';
import setObj from './methods/setObj';
import { UPGRADE_STRATEGY } from '../consts/upgrade-strategy';

const HPP_UPGRADE_STRATEGY = 'hpp_upgrade_strategy';

/**
 * 初始化升级策略数据
 */
export function initUpgradeStrategy(upgradeStrategy = UPGRADE_STRATEGY) {
  const countryMap = upgradeStrategy.reduce((obj, item) => {
    obj[item.country] = item;
    return obj;
  }, {});
  setObj(HPP_UPGRADE_STRATEGY, countryMap);
}

/**
 * 获取某个国家的升级策略
 * @param {string | number | undefined} country 国家code
 * @returns {{ country: string; epProStrategy: { deadLine: number; strategy: number; }; hikIdStrategy: { deadLine: number; strategy: number; }; showEP: boolean; showEpWord: boolean; }}
 */
export function getUpgradeStrategy(country) {
  const countryMap = getObj(HPP_UPGRADE_STRATEGY);
  if (country === undefined) {
    return countryMap;
  }
  if (countryMap) {
    return countryMap[country];
  }
}

/**
 * 获取某个国家的onehikid升级策略
 * @param {string | number | undefined} country 国家code
 * @returns {number}
 */
export function getOneHikIdUpgradeStrategy(country) {
  const countryMap = getObj(HPP_UPGRADE_STRATEGY);
  if (countryMap) {
    return countryMap[country]?.hikIdStrategy.strategy;
  }
}

/**
 * 获取某个国家的用户升级策略
 * @param {string | number | undefined} country 国家code
 * @returns {number}
 */
export function getUserUpgradeStrategy(country) {
  const countryMap = getObj(HPP_UPGRADE_STRATEGY);
  if (countryMap) {
    return countryMap[country]?.epProStrategy.strategy;
  }
}

/**
 * 获取用户是否要进入升级流程的策略
 * @param {string | number | undefined} country 国家code
 * @returns {number}
 */
export function isAccountNeedUpgrade(country) {
  const countryMap = getObj(HPP_UPGRADE_STRATEGY);
  if (countryMap?.[country]) {
    const hikIdStrategy = countryMap[country].hikIdStrategy.strategy;
    const epProStrategy = countryMap[country].epProStrategy.strategy;
    return Math.max(hikIdStrategy, epProStrategy);
  }
  return -1;
}
